<ion-item-divider>
	<div class="appointment">
		<div class="appointment__header">
			<div class="circle"></div>
			<div class="appointment__title"></div>
			<div class="appointment__subtitle"></div>
		</div>
		<div class="appointment__travel">
			<div class="appointment__address"></div>
			<div class="appointment__arrival">
				<div class="time">
					<span class="time__icon"></span>
					<span class="time__time"></span>
				</div>
				<div class="time">
					<span class="time__icon"></span>
					<span class="time__time"></span>
				</div>
				<div class="appointment__block-description"></div>
				<div class="appointment__ticket-priority"></div>
			</div>
		</div>
		<div class="appointment__actions">
			<div class="button--skeleton"></div>
			<div class="button--skeleton"></div>
			<div class="button--skeleton"></div>
		</div>
	</div>
</ion-item-divider>
